import { render, staticRenderFns } from "./extra-formular.vue?vue&type=template&id=2a6308b6&lang=pug&"
import script from "./extra-formular.vue?vue&type=script&lang=js&"
export * from "./extra-formular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports